import { baseRequest } from '@thrivadev/thriva-request';
import { USER_API_PATH } from './helpers';
const requestOptions = {
    method: 'GET'
};
/**
 * ```js
 * import { getSelf } from '@thrivadev/thriva-user';
 * //
 * getSelf();
 * ```
 * User request.
 * @param apiOptions - The options to use for this request.
 * @returns A promise that resolves with the user details.
 */
export function getSelf(apiOptions) {
    return baseRequest(USER_API_PATH, requestOptions, apiOptions);
}
//# sourceMappingURL=get.js.map